import { OktaAuth } from '../default';

// Export only a single object
export default OktaAuth;
